import { PostHogProvider } from "posthog-js/react";
import posthog from "./posthog";

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <PostHogProvider client={posthog}>
      {/* Add future providers here */}
      {children}
    </PostHogProvider>
  );
}
